<template>
  <span>
    <div :title="getTitle()" @click="displayFileInfoButtonsDialog($event)" class="fileInfoButton" v-if="hasMenu()"><Icon icon="material-symbols:menu-rounded" width="22" /></div>
    <div :title="getTitle()" @click="downloadFile" class="fileInfoButton" v-if="!hasMenu()"><Icon icon="material-symbols:file-present-outline" width="22" /></div>
  </span>

  <q-dialog v-model="fileInfoButtonsDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm fileInfoButtonsDiv" :style="fileInfoButtonsDivStyle()">
        <q-card style="border-radius: 10px;" class="q-pa-md">
          <div align="right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin: -15px -10px 0px 0px;" /></div>

          <q-card-actions align="center" class="text-primary">
            <div title="Folder Structure" @click="displayFolder" class="fileInfoButton" v-close-popup v-if="hasFolderStructure()"><Icon icon="mdi:folder-outline" width="22" /></div>
            <div title="Zip Structure" @click="displayTreeModal" class="fileInfoButton" v-close-popup v-if="hasZipStructure()"><Icon icon="mdi:file-tree-outline" width="22" /></div>
            <div title="File Preview" @click="downloadFile" class="fileInfoButton" v-close-popup><Icon icon="material-symbols:file-present-outline" width="22" /></div>
            <div title="Share Document" @click="shareFile" class="fileInfoButton" v-if="hasShareDocument()"><Icon icon="uil:share" width="22" /></div>
            <div title="Edit Document" @click="editMetadata" class="fileInfoButton" v-close-popup v-if="hasUserEditAccessLevel()"><Icon icon="material-symbols:edit" width="22" /></div>
            <div title="Delete Document" @click="deleteFile" class="fileInfoButton" v-close-popup v-if="hasUserDeleteAccessLevel()"><Icon icon="material-symbols:delete" width="22" /></div>
            <div id="linkCopiedDiv" style="margin-top: 10px; display: none;">Link copied to clipboard</div>
          </q-card-actions>
        </q-card>
      </div>
    </div>
  </q-dialog>
</template>

<script >
import { Icon } from '@iconify/vue';
import { ref } from "vue";
import CommonHelper from '../helper/CommonHelper';

export default {
  name: "FileInfoButtons",
  methods: {
    displayFolder() {
      this.params.displayFolder(`${this.params.value[2]}:::${this.params.value[3]}`);
    },

    displayTreeModal() {
      this.params.displayTreeModal(this.params.value[0], this.params.value[1]);
    },

    downloadFile() {
      this.params.downloadFile(this.params.value[0], this.params.value[1]);
    },

    shareFile() {
      navigator.clipboard.writeText(`${process.env.VUE_APP_URL}?document_id=${this.params.value[0]}`);
      document.getElementById("linkCopiedDiv").style.display = "block";
    },

    editMetadata() {
      this.params.editMetadata(this.params.value[0]);
    },

    deleteFile() {
      this.params.deleteFile(this.params.value[0], this.params.value[1], this.params.value[2]);
    },

    hasFolderStructure() {
      return this.params.value[3] !== "";
    },

    hasZipStructure() {
      return this.params.value[1].endsWith(".zip") && CommonHelper.storedZipFileData.value[this.params.value[0]];
    },

    hasShareDocument() {
      return window.origin === process.env.VUE_APP_URL;
    },

    hasUserEditAccessLevel() {
      return this.params.userEditAccessLevel && !CommonHelper.nonEditList.includes(this.params.value[2]);
    },

    hasUserDeleteAccessLevel() {
      return this.params.userDeleteAccessLevel && !CommonHelper.nonDeleteList.includes(this.params.value[2]);
    },

    hasMenu() {
      return this.hasFolderStructure() || this.hasZipStructure() || this.hasShareDocument() || this.hasUserEditAccessLevel() || this.hasUserDeleteAccessLevel();
    },

    getTitle() {
      return this.params.value[4];
    },

    fileInfoButtonsDivStyle() {
      let width = 120;

      if (this.hasFolderStructure()) {
        width += 30;
      }

      if (this.hasZipStructure()) {
        width += 30;
      }

      if (this.hasShareDocument()) {
        width += 30;
      }

      if (this.hasUserEditAccessLevel()) {
        width += 30;
      }

      if (this.hasUserDeleteAccessLevel()) {
        width += 30;
      }

      return `width: ${width}px`;
    }
  },
  components: {
    Icon,
  },
  setup() {
    const fileInfoButtonsDialog =  ref(false);

    /*
     * Displays the fileInfoButtonsDialog modal
     */
    function displayFileInfoButtonsDialog(event) {
      document.documentElement.style.setProperty("--fileInfoButtonsDivLeft", event.clientX + "px");
      document.documentElement.style.setProperty("--fileInfoButtonsDivTop", event.clientY + "px");
      fileInfoButtonsDialog.value = true;
    }

    return {
      //variable properties
      fileInfoButtonsDialog,

      //functions
      displayFileInfoButtonsDialog
    }
  }
}
</script>

<style>
:root {
  --fileInfoButtonsDivLeft: 600px;
  --fileInfoButtonsDivTop: 200px;
}

.fileInfoButton {
  margin-top: 5px;
  margin-right: 8px;
  cursor: pointer;
}

.fileInfoButtonsDiv {
  margin-left: var(--fileInfoButtonsDivLeft);
  margin-top: var(--fileInfoButtonsDivTop);
  border-radius: 10px;
}
</style>